import { getEnv, getSecureAccelerateDealerUrl } from '@makemydeal/dr-sales-checkin-ui-utils';
import { CREDIT_APP_MODE } from './constants';

/**
 * Get the credit app base URL based on environment for standalone mode
 * Follows the same pattern as documented in Credit-App-Modes-Comparison.md
 * Example (qa): https://secure-qa.accelerate.dealer.com/dealer
 * This will further take dealer Id from the logged in user context to work correctly
 */
const getCreditAppUrl = (): string => {
    const env = getEnv();
    return getSecureAccelerateDealerUrl(env);
};

// Credit application configuration
export const creditConfig = {
    creditAppUrl: getCreditAppUrl(),
    mode: CREDIT_APP_MODE
};
